import { Alert, Col, Row, Table, Tabs } from "antd";
import { useContext, useEffect, useState } from "react";
import { TabPane } from "semantic-ui-react";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { TemplateContext } from "../../../../utils/template_context";

export const Experiencia = ({ jurado }: any) => {
  const context = useContext(TemplateContext);
  const [totalTiempoProfesional, setTotalTiempoProfesional] = useState<{ anios: number; meses: number }>({ anios: 0, meses: 0 });

  const calcularDiferenciaAniosMeses = (inicioStr?: string, finStr?: string) => {
    if (!inicioStr || !finStr) return { anios: 0, meses: 0 };
    const [yi, mi, di] = inicioStr.split("-").map((v: string) => parseInt(v, 10));
    const [yf, mf, df] = finStr.split("-").map((v: string) => parseInt(v, 10));
    if ([yi, mi, di, yf, mf, df].some((v) => Number.isNaN(v))) return { anios: 0, meses: 0 };
    const inicio = new Date(yi, (mi || 1) - 1, di || 1);
    const fin = new Date(yf, (mf || 1) - 1, df || 1);
    if (fin < inicio) return { anios: 0, meses: 0 };
    let totalMeses = (fin.getFullYear() - inicio.getFullYear()) * 12 + (fin.getMonth() - inicio.getMonth());
    if (fin.getDate() < inicio.getDate()) totalMeses -= 1;
    const anios = Math.floor(totalMeses / 12);
    const meses = totalMeses % 12;
    return { anios, meses };
  };

  useEffect(() => {
    const lista = jurado?.experiencias_profesionales;
    if (!Array.isArray(lista)) {
      setTotalTiempoProfesional({ anios: 0, meses: 0 });
      return;
    }
    let totalMeses = 0;
    lista.forEach((exp: any) => {
      const { anios, meses } = calcularDiferenciaAniosMeses(exp?.fecha_inicio, exp?.fecha_terminacion);
      totalMeses += anios * 12 + meses;
    });
    setTotalTiempoProfesional({ anios: Math.floor(totalMeses / 12), meses: totalMeses % 12 });
  }, [jurado?.experiencias_profesionales]);
  const columnsProfesional: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Nombre entidad",
      width: 200,
      dataIndex: "nombre",
      key: "nombre",
      render: (text: string) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {text}
        </div>
      ),
    },
    {
      title: "Funciones principales",
      width: 200,
      dataIndex: "funciones",
      key: "funciones",
      render: (text: string) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {text}
        </div>
      ),
    },
    {
      title: "Fecha de inicio",
      width: 140,
      dataIndex: "fecha_inicio",
      key: "fecha_inicio",
    },
    {
      title: "Fecha de terminación",
      width: 140,
      dataIndex: "fecha_terminacion",
      key: "fecha_terminacion",
    },
    {
      title: "Tiempo total",
      width: 140,
      key: "tiempo_total",
      render: (datos: any) => {
        const { anios, meses } = calcularDiferenciaAniosMeses(datos?.fecha_inicio, datos?.fecha_terminacion);
        const partes: string[] = [];
        if (anios > 0) partes.push(`${anios} año${anios !== 1 ? "s" : ""}`);
        if (meses > 0 || anios === 0) partes.push(`${meses} mes${meses !== 1 ? "es" : ""}`);
        return partes.join(" ");
      },
    },
    {
      title: "Cargo/Rol desempeñado",
      width: 140,
      dataIndex: "cargo",
      key: "cargo",
      render: (text: string) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {text}
        </div>
      ),
    },
    {
      title: "Anexo",
      width: 70,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <button type="button" className="button-azul-ghost" onClick={() => modalAnexo(datos)}>
          Anexo
        </button>
      ),
    },
  ];
  const columnsJurado: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Nombre convocatoria",
      width: 200,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (text: string) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {text}
        </div>
      ),
    },
    {
      title: "Entidad",
      width: 140,
      dataIndex: "entidad",
      key: "entidad",
      render: (text: string) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {text}
        </div>
      ),
    },
    {
      title: "Ciudad",
      width: 140,
      dataIndex: "ciudad",
      key: "ciudad",
    },
    {
      title: "Año",
      width: 140,
      dataIndex: "anio",
      key: "anio",
    },
    {
      title: "Expresión",
      width: 140,
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Anexo",
      width: 70,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <button type="button" className="button-azul-ghost" onClick={() => modalAnexo(datos)}>
          Anexo
        </button>
      ),
    },
  ];

  const [openModal, setOpenModal] = useState(false);
  const [documento, setDocumento] = useState("");
  const modalAnexo = (datos: any) => {
    setDocumento(datos.documento);
    setOpenModal(true);
  };

  return (
    <>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Experiencia profesional" key="1">
          {jurado.experiencias_profesionales !== null &&
          jurado.experiencias_profesionales.length !== 0 ? (
            <Row>
              <Col>
                <Table
                  dataSource={jurado.experiencias_profesionales}
                  columns={columnsProfesional}
                  pagination={false}
                  scroll={{ x: 1500, y: 300 }}
                />
                <div className="mt-2 mb-3 d-flex justify-content-end">
                  <span className="font-family-Montserrat-SemiBold font-size-14px">
                    Total acumulado: {`${totalTiempoProfesional.anios} año${totalTiempoProfesional.anios !== 1 ? "s" : ""} ${totalTiempoProfesional.meses} mes${totalTiempoProfesional.meses !== 1 ? "es" : ""}`}
                  </span>
                </div>
              </Col>
            </Row>
          ) : (
            <Alert message="No se han diligenciados datos para está sección" type="warning" />
          )}
        </TabPane>
        <TabPane tab="Experiencia en formulación, ejecución y evaluación de proyectos" key="2">
          {jurado.experiencias ? (
            <Row>
              <Col>
                <Table
                  dataSource={jurado.experiencias}
                  columns={columnsJurado}
                  pagination={false}
                  scroll={{ x: 1500, y: 300 }}
                />
              </Col>
            </Row>
          ) : (
            <Alert message="No se han diligenciados datos para está sección" type="warning" />
          )}
        </TabPane>
      </Tabs>
      {openModal && (
        <ModalVisualizarDocumentos
          visualizar={openModal}
          setVisualizar={setOpenModal}
          state={{ documento }}
        />
      )}
    </>
  );
};
